import { fetchJsonResponse } from '@/ai/api'
import { buildSingleEventPrompt } from '@/ai/prompts'

export const generateSingleEvent = async ({
  parentEventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleEventPrompt({
    parentEventId,
    workflow,
    svgGraph,
    svgLanes,
    cardTypes
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
